export default __webpack_public_path__ + "static/media/tylerrake001.e1688092.jpeg";